import React, { memo, type PropsWithChildren, type ReactNode } from 'react';
import { Spotlight, SpotlightPulse, SpotlightTransition } from '@atlaskit/onboarding';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import messages from './SavedViewsOnboarding.messages.tsx';

type Props = PropsWithChildren<{
	isAdmin?: boolean;
	isOnboardingVisible: boolean;
	markAsSeen: () => void;
}>;

// TODO: SLV-286 - delete this file during spotlight cleanup

export const SavedViewsOnboarding = memo(
	({ children, isAdmin = false, isOnboardingVisible, markAsSeen }: Props) => {
		const { formatMessage } = useIntl();

		return (
			<>
				<SpotlightPulse radius={3} pulse={isOnboardingVisible}>
					{children}
				</SpotlightPulse>
				{isOnboardingVisible && (
					<SpotlightTransition>
						<Spotlight
							actions={[
								{
									onClick: () => {
										markAsSeen();
									},
									text: formatMessage(messages.spotlightDismissButton),
								},
								{
									onClick: () => {
										markAsSeen();
										// TODO: SLV-275 - add link to documentation
									},
									text: formatMessage(messages.spotlightLearnMoreButton),
								},
							]}
							heading={formatMessage(
								isAdmin ? messages.adminSpotlightTitle : messages.spotlightTitle,
							)}
							target="jira-nin-saved-views-dropdown-content"
							targetRadius={3}
							dialogWidth={275}
							pulse={false}
							dialogPlacement={isAdmin ? 'left top' : 'bottom right'}
						>
							<Stack space="space.100">
								{formatMessage(
									isAdmin ? messages.adminSpotlightMessage : messages.spotlightMessage,
									{
										p: (chunks: ReactNode[]) => <Text as="p">{chunks}</Text>,
									},
								)}
							</Stack>
						</Spotlight>
					</SpotlightTransition>
				)}
			</>
		);
	},
);
